module.exports = __webpack_public_path__ + "img/company.49f464c4.jpg";